
import { defineComponent, ref, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { ElMessage, ElMessageBox } from "element-plus";
import { PostcardRewardConfig } from "@/store/modules/PostcardRewardModule";

export default defineComponent({
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("明信片奖励配置", [
        "明信片奖励管理;postcard_reward_configs",
      ]);
    });

    const store = useStore();
    const tableData = ref<PostcardRewardConfig[]>([]);

    const formData = ref({
      name: "",
      reward_type: "",
      status: "",
    });

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
    });

    const query = () => {
      store
        .dispatch(Actions.GET_POSTCARD_REWARD_CONFIGS, {
          ...formData.value,
          ...page.value,
        })
        .then(() => {
          tableData.value = store.getters.currentPostcardRewardConfigs;
          page.value.totalResult =
            store.getters.currentPostcardRewardConfigCount;
        })
        .catch(() => {
          ElMessage.error("获取配置列表失败");
        });
    };

    query();

    const submitEvent = () => {
      page.value.currentPage = 1;
      query();
    };

    const onPageChange = (e: { currentPage: number; pageSize: number }) => {
      page.value.currentPage = e.currentPage;
      page.value.pageSize = e.pageSize;
      query();
    };

    const onReset = () => {
      formData.value = {
        name: "",
        reward_type: "",
        status: "",
      };
      page.value.currentPage = 1;
      query();
    };

    const formatDate = (dateStr: string) => {
      if (!dateStr) return "";
      return dateStr.slice(0, 16).replace("T", " ");
    };

    const onDelete = (row: PostcardRewardConfig) => {
      ElMessageBox.confirm(`确定要删除配置"${row.name}"吗？`, "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          store
            .dispatch(Actions.DELETE_POSTCARD_REWARD_CONFIG, row.id)
            .then(() => {
              ElMessage.success("删除成功");
              query();
            })
            .catch(() => {
              ElMessage.error("删除失败");
            });
        })
        .catch(() => {
          // 取消删除
        });
    };

    return {
      tableData,
      formData,
      submitEvent,
      page,
      onPageChange,
      onReset,
      formatDate,
      onDelete,
    };
  },
});
